import * as React from "react";

export const DeleteIconRed = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#F43636"
      d="M12 6.75v7.5H6v-7.5h6Zm-1.125-4.5h-3.75l-.75.75H3.75v1.5h10.5V3h-2.625l-.75-.75Zm2.625 3h-9v9c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-9Z"
      opacity={0.8}
    />
  </svg>
);
